<template>
  <ShopHeader />
  <ContentWrap>
    <h2 class="myOrder">我的订单</h2>
    <ElTable :data="orderLIst" style="width: 100%" empty-text="暂无数据">
      <ElTableColumn prop="outTradeNo" label="订单号" width="180">
      </ElTableColumn>
      <ElTableColumn prop="createTime" label="创建时间" width="180">
      </ElTableColumn>
      <ElTableColumn prop="description" label="商品名称"> </ElTableColumn>
      <ElTableColumn prop="tradeState" label="订单状态">
        <template #default="{row}">
          <span>{{ payStats[row.tradeState] }}</span>
        </template>
      </ElTableColumn>
      <ElTableColumn prop="total" label="付款金额" width="180">
        <template #default="{row}">
          <span>¥{{ row.total / 100 }}</span>
        </template>
      </ElTableColumn>
      <ElTableColumn label="操作">
        <template #default="{row}">
          <ElButton size="mini" @click="toGood(row.itemId)">查看商品</ElButton>
          <ElButton
            size="mini"
            v-if="row.tradeState === 'SUCCESS'"
            @click="tuikuan(row.outTradeNo)"
            >申请退款</ElButton
          >
        </template>
      </ElTableColumn>
    </ElTable>
  </ContentWrap>
</template>
<script>
import { getCookie } from '@/utils/cookie'
import ShopHeader from '../Layout/shopHeader.vue'
import ContentWrap from '../Layout/contentWrap.vue'
import {
  ElButton,
  ElTable,
  ElTableColumn,
  ElMessageBox,
  ElMessage,
} from 'element-plus'
import { goodsOrderList, orderRefund } from '@/api/orderList'
export default {
  components: {
    ShopHeader,
    ContentWrap,
    ElTable,
    ElTableColumn,
    ElButton,
  },
  data() {
    return {
      orderLIst: null,
      payStats: {
        NOTPAY: '未支付',
        SUCCESS: '支付成功',
        REFUND: '转入退款',
        CLOSED: '已关闭',
        REVOKED: '已撤销',
        USERPAYING: '支付中',
        PAYERROR: '支付失败',
        ACCEPT: '等待扣款',
      },
    }
  },
  mounted() {
    // 获取订单列表
    this.goodsOrderList()
  },
  methods: {
    // 获取订单列表
    async goodsOrderList() {
      const res = await goodsOrderList(getCookie('phone'))
      this.orderLIst = res.data
    },
    async tuikuan(outTradeNo) {
      try {
        await ElMessageBox.confirm('确定申请退款吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        const res = await orderRefund(outTradeNo)
        if (res.status !== 200) return ElMessage.error('申请退款失败')
        ElMessage.success('申请退款成功')
        // 获取订单列表
        this.goodsOrderList()
      } catch (error) {
        ElMessage.info('取消操作')
      }
    },
    toGood(itemId) {
      this.$router.push({
        path: '/goodInfo',
        query: {
          goodsId: itemId,
        },
      })
    },
  },
}
</script>
<style>
.myOrder {
  height: 80px;
  line-height: 80px;
  text-align: left;
  font-size: 20px;
}
</style>
